import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/cgfns.css';
import logo from '../../../assets/image/TruMerit_CGFNS_Message-Reverse.png';
import { FaBell } from 'react-icons/fa';
import { TiHome } from "react-icons/ti";
import { useTranslation } from 'react-i18next';
import SFLink from '../../../azureLogin/SFLink';
import { AuthenticatedTemplate } from '@azure/msal-react';
import useAuth from '../../../azureLogin/useAuth';
import { useState ,useEffect } from 'react';
import axios from 'axios';
import Notifications from '../../cNotifications';
const Header = () => {
  const { t, i18n } = useTranslation();
  const [userName, setUserName] = useState('');
  const [contactId, setContactId] = useState(''); 
  const { token,fetchData,logout } = useAuth();

  useEffect(() => {
    const fetchDetails = async () => {
     

      let config = {
        method: 'get',
        maxBodyLength: Infinity,
        headers: {
          'accept': 'application/json'
        }
      };

      try {
        fetchData('/Contact/me?fields=CommunityUserID__c%2CId%2CAccountId%2CApplicant_ID__c%2CEmail%2CPhone%2CName%2CAvailableApplications.Id%2CAvailableApplications.Name%2CAvailableApplications.Program_Name__c%2CAvailableApplications.Price__c%2CAvailableApplications.URLFormAssemblyID__c%2CAvailableApplications.Complete_Percentage__c%2CAvailableApplications.MakeApplicationAvailableManually__c%2CAvailableApplications.EducationRequirementHelpText__c%2CAvailableApplications.Additional_Services_Order__c%2CAvailableApplications.Add_on_count__c%2CAvailableApplications.Additional_Order_Count__c%2CAvailableApplications.Add_on_count_un_paid__c%2CAvailableApplications.Additional_Order_Un_Paid__c%2CAvailableApplications.Total_Additional_Recipients__c%2CAvailableApplications.Total_Expedited_Service__c%2CAvailableApplications.Total_Express_Mail_Service__c%2CAvailableApplications.ParentApplication__c%2CAvailableApplications.Application_Expired__c%2CAvailableApplications.Additional_Recipient_Order__c%2CAvailableApplications.Re_Evaluation_Order__c%2CAvailableApplications.WorkRequirementHelpText__c%2CAvailableApplications.LicenseRequirementHelpText__c%2CAvailableApplications.IDRequirementHelpText__c%2CAvailableApplications.Update_EduHis_for_Eligibility__c%2CAvailableApplications.Update_ID_for_Eligibility__c%2CAvailableApplications.Program_Report_Recipient__c%2CAvailableApplications.Update_WH_for_Eligibility__c%2CAvailableApplications.UpdateLicensesforEligibility__c%2CAvailableApplications.Contact__c%2CAvailableApplications.is_Payment_Made__c%2CAvailableApplications.PaymentReceived__c%2CAvailableApplications.Chargent_Order__c%2CAvailableApplications.Description__c%2CAvailableApplications.RuleCode__c%2CAvailableApplications.isICDApplication__c%2CAvailableApplications.application_expiration_date__c%2CAvailableApplications.Internal_Status__c%2CAvailableApplications.order_Payment_Date__c%2CAvailableApplications.External_Status__c%2CAvailableApplications.Additional_Recipient_Needed__c%2CAvailableApplications.ICD_Program_Recipient_Edit_Ability__c%2CAvailableApplications.Program_Report_Link__c%2CAvailableApplications.Badge_Link__c%2CAvailableApplications.Re_Evaluation_Needed__c%2CAvailableApplications.PortalCode__c%2CAvailableApplications.Unpaid_App__c%2CAvailableApplications.Complete_Percentage__c',config)
        .then(function (response) {
        // const response = await axios.request(config);
        const resdata = response?.data;
        setUserName(resdata?.Name);
        setContactId(resdata?.CommunityUserID__c);
      })}
        catch (error) {
          console.log('Error fetching data', error);
        }
        
      };
      fetchDetails();
  }, [fetchData, token]);

  return (
    <AuthenticatedTemplate>
    <nav className="navbar navbar-expand-lg navbar-custom-cgfns">
      <div className="container-fluid">
        <a className="navbar-brand">
          <img src={logo} alt="CGFNS Logo" width="180" />
        </a>
        <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarNav">
          <ul className="navbar-nav m-auto">
            <li className="nav-item1-cgfns">
              <a className="nav-link" href="/cgfns/home"> <TiHome size={20} /></a>
            </li>
     
            <li className="nav-item1-cgfns">
              <SFLink path="/applicantPortal/s/profile-v1" variant="a" className="nav-link">{t('BMCServiceDesk__SSMyProfile')}</SFLink>
            </li>
            <li className="nav-item1-cgfns">
            <SFLink path="/applicantPortal/s/portfolio-check"  variant="a" className="nav-link">{t('My_Portfolio')}</SFLink>
            </li>
            <li className="nav-item1-cgfns">
            <SFLink path="/applicantPortal/s/chargent-payment" variant="a" className="nav-link">{t('Shopping_Cart_tabs')}</SFLink>
            </li>
            <li className="nav-item1-cgfns">
            <a className="nav-link" href="./orderhistory?isICD=false">{t('Transaction_History')}</a>
            </li>
            <li className="nav-item1-cgfns">
            <SFLink path="/applicantPortal/s/support" variant="a" className="nav-link">{t('Support_tabs')}</SFLink>
            </li>
          
          </ul>
          <ul className="navbar-nav">
            <li className="nav-item">              
                <Notifications />              
            </li>
            <li className="nav-item dropdown">
              {/* <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                Username
              </a> */}
                <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                {userName}
              </a>
              <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                <li><a className="dropdown-item" href="/cgfns/home">{t('BMCServiceDesk__adminHomeTabLabel')}</a></li>
                <li><SFLink variant="a"  className="dropdown-item" path={`/applicantPortal/s/profile/${contactId}`}>{t('BMCServiceDesk__UserSettings')}</SFLink></li>
                <li><hr className="dropdown-divider" /></li>
                <li><a className="dropdown-item" href="#" onClick={logout}>{t('BMCServiceDesk__SDEHomeLogout')}</a></li>
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </nav>
    </AuthenticatedTemplate>
  );
};

 export default Header;
